import ResourceActionsContainer from './containers/ResourceActionsContainer.ts'
import CallbackLinkAction from './components/actions/CallbackLinkAction.tsx'
import LinkAction from './components/actions/LinkAction.tsx'

export const containers = {
  ResourceActionsContainer,
}

export const components = {
  CallbackLinkAction,
  LinkAction,
}
